export default __webpack_public_path__ + "static/media/app-image.2ba67f8b.jpg";